import React from 'react';
import '../assets/scss/loading.scss';

export default function () {
  return (
    <div className="container-loading">
      <div className="loading">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </div>
  );
}
